import { Spinner } from "reactstrap";
import { Button, Typography } from "@mui/material";
import { styles } from "../../pages/Mint/styles";
import { Link } from "react-router-dom";
import { MintTermsAndConditionsProps } from "./types";
import { mintTermsAndConditionsStyles } from "./styles";
import { FONT_FAMILY } from "../../theme";

export const MintTermsAndConditions: React.FC<MintTermsAndConditionsProps> = ({
  isChecked,
  handleCheckboxChange,
  isSubmitting,
  connectedWallet,
}) => {
  return (
    <>
      <div style={mintTermsAndConditionsStyles.container}>
        <span style={{ fontFamily: FONT_FAMILY }}>
          <input
            className="checkbox-mint"
            type="checkbox"
            checked={isChecked}
            style={{ marginRight: 10 }}
            onChange={handleCheckboxChange}
          />
          I agree to{" "}
          <Link
            style={{ textDecoration: "none" }}
            to="/terms-of-use"
            target="_blank"
          >
            Terms of Use
          </Link>
          ,{" "}
          <Link
            style={{ textDecoration: "none" }}
            to="/creator-agreement"
            target="_blank"
          >
            Creator Agreement
          </Link>
          , and{" "}
          <Link
            style={{ textDecoration: "none" }}
            to="/privacy-policy"
            target="_blank"
          >
            Privacy Policy
          </Link>
          . I have verified equity distribution with all contributing artists. I
          agree to a 5% royalty fee for OmMuse on sale of NFT.
        </span>
      </div>

      <hr />

      <Button
        disabled={isSubmitting || !isChecked}
        fullWidth
        type="submit"
        sx={styles.submitButton}
        size="small"
        variant="contained"
      >
        {isSubmitting ? (
          <>
            <Spinner
              as="span"
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
              color="black"
            />{" "}
            <span style={mintTermsAndConditionsStyles.uploadingMediaSpan}>
              Uploading Media...
            </span>
          </>
        ) : (
          <Typography
            variant="h1"
            sx={mintTermsAndConditionsStyles.publishMintTypography}
          >
            Publish / Mint
          </Typography>
        )}
      </Button>

      {!connectedWallet && (
        <div className="text-danger mt-2">the wallet is not connected</div>
      )}
    </>
  );
};
